import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "CAMNavLazy" */ './CAMNav'), {
    fallback: null,
});
